import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXmarkMui = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.6875 11.1875L8.03906 6.5L12.6875 1.85156C13.0781 1.5 13.0781 0.914062 12.6875 0.5625C12.3359 0.171875 11.75 0.171875 11.3984 0.5625L6.75 5.21094L2.0625 0.5625C1.71094 0.171875 1.125 0.171875 0.773438 0.5625C0.382812 0.914062 0.382812 1.5 0.773438 1.85156L5.42188 6.5L0.773438 11.1875C0.382812 11.5391 0.382812 12.125 0.773438 12.4766C1.125 12.8672 1.71094 12.8672 2.0625 12.4766L6.75 7.82812L11.3984 12.4766C11.75 12.8672 12.3359 12.8672 12.6875 12.4766C13.0781 12.125 13.0781 11.5391 12.6875 11.1875Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgXmarkMui);
export { ForwardRef as ReactComponent };
